// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"833":"5d439c25","979":"91273c59"}[chunkId] + ".chunk.css";
};